import { IGetBacklinksQuery, OverrideSQuery } from '@rhizome/pgtypes';
import { convertDBRowToSlateNode } from '@rhizome/shared-slate-utils';
import { ExpandLess, ExpandMore } from '@styled-icons/material';
import Link from 'next/link';
import { useState } from 'react';
import styled from 'styled-components';
import { DarkenMedium, DarkenSlightly } from '../../../styles/themes';
import { useFetcher } from '../../../utils/DataFetchers';
import { usePrivacy } from '../../../utils/usePrivacy';
import { LoadingPulser } from '../../StatusUI/LoadingPulser';
import { ReadOnlyDisplay } from '../usedPlugins';

export function BlockWrapperBacklinks(props: {
  backlinks: string[];
  block_id: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <BWBacklinksContainer>
      <BacklinksBar
        onClick={() => {
          setOpen(!open);
        }}
      >
        {props.backlinks.length} link{props.backlinks.length > 1 ? 's' : ''} to
        this block{' '}
        {/* TODO: very strange that removing this resolves 
            the 

            NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.

            bug. Very strange. At any rate, probably better UX to prevent the user
            from opening an infinite recursive hole of block references.

            This is fixed now. The following lines of code (the two icons) were once wrapped
            in a span element - removing the span fixed the bug for some reason! Not sure why.

          */}
        {open ? (
          <ExpandLess height="1rem" style={{ verticalAlign: 'middle' }} />
        ) : (
          <ExpandMore height="1rem" style={{ verticalAlign: 'middle' }} />
        )}
      </BacklinksBar>

      {open ? (
        <div style={{ width: '100%' }}>
          <BWBacklinksDisplay block_id={props.block_id} />
        </div>
      ) : null}
    </BWBacklinksContainer>
  );
}

const BWBacklinksDisplay = function (props: { block_id: string }) {
  const isPublic = usePrivacy() === 'public';
  const { data: backlinks } = useFetcher<OverrideSQuery<IGetBacklinksQuery>>(
    [
      'GetBacklinks',
      {
        block_id: props.block_id,
      },
    ],
    {
      skipAuth: isPublic,
    }
  );

  return (
    <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
      {backlinks ? (
        backlinks.map((backlink) => {
          const title = backlink.note_title || 'untitled';
          const privateLink =
            '/notes/editor/' + backlink.slate_parent + '#' + backlink.block_id;

          const publicLink =
            '/post/' +
            backlink.slate_parent +
            '/' +
            '?excerpt=' +
            backlink.block_id;
          return (
            <div key={backlink.block_id} style={{ marginBottom: '10px' }}>
              <Link href={isPublic ? publicLink : privateLink} passHref>
                <div
                  style={{ textDecoration: 'underline', paddingLeft: '0.5rem' }}
                >
                  from {title}
                </div>
              </Link>
              <ReadOnlyDisplay
                nodes={[convertDBRowToSlateNode(backlink)]}
                isRoot={false}
              />
            </div>
          );
        })
      ) : (
        <LoadingPulser />
      )}
    </div>
  );
};

const BWBacklinksContainer = styled.div`
  display: inline-block;
  background-color: ${DarkenSlightly};
  padding: 0.15rem;
  border-radius: 0.2rem;
  margin-top: 5px;
  outline: 1px solid gray;
  :hover {
    background-color: ${DarkenMedium};
  }
`;

const BacklinksBar = styled.div`
  font-size: 0.8rem;
`;
